<template>
  <b-modal
    :id="`import-campaign-modal`"
    :modal-class="'default-modal'"
    header-class="justify-content-between"
    :hide-footer="true"
    @hidden="hidden"
    @shown="shown"
  >

    <template #modal-header="{ close }">
      <div class="text-center">
        <h2 class="highlighted-color1">
          <span>Importar campanha</span>
        </h2>
      </div>
      <!--begin::Close-->
      <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close" @click="close()">
          <span class="svg-icon svg-icon-1">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor"></rect>
            <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor"></rect>
            </svg>
          </span>
      </div>
      <!--end::Close-->
    </template>
    <AlertWraper
      :content="content"
      :type="content_type"
    />
    <div>
        <form class="default-form" @submit.prevent="">
          <template v-if="platform == 'GOOGLE'">
            <div class="text-center">
              Selecione a qual empresa você deseja vincular a campanha <strong>{{ campaign?.name }}</strong>.
            </div>
            <div class="form-group row mb-5 text-start">
              <div class="col-12">
                <label class="required form-label">Empresa</label>
                <SelectCompanyInput
                  v-model="form.company_id"
                />
              </div>
            </div>
            <!--begin: type -->
            <div class="form-group mb-5">
              <label class="required form-label"> Tipo da campanha </label>
              <select class="form-select" v-model.trim="form.campaign_type">
                <option value="">Selecione</option>
                <option value="NATIVE">Native</option>
                <option value="PROGRAMMATIC">Programática</option>
                <option value="NATIVE_OPEN">Native Open</option>
                <option value="YOUTUBE">Youtube</option>
                <option value="AUDIO">Áudio</option>
              </select>
            </div>
            <!--end: type -->
          </template>
          <template v-else>
            <div class="text-center">
              Selecione a qual anunciante você deseja vincular a campanha <strong>{{ campaign?.name }}</strong>.
            </div>
            <div class="form-group row mb-5">
              <div class="col-12">
                <label class="required form-label">Anunciante</label>
                <SelectAdvertiserInput
                  v-model="form.advertiser_id"
                />
              </div>
            </div>
            <div class="form-group row mb-5">
              <div class="col-12">
                <label class="required form-label">Orçamento vendido</label>
                <Money
                  class="form-control"
                  v-model.trim="form.sold_amount"
                  v-bind="money"
                />
              </div>
            </div>
            <div class="d-flex mb-5">
              <div class="col-lg-6">
                <label class="required form-label">Início da campanha</label>
                <DateTimeInput
                  v-model.trim="form.start_date"
                  format="dd/MM/yyyy"
                  type="date"
                  theme="basic"
                  class="mx-2"
                  placeholder="Início"
                />
              </div>
              <div class="col-lg-6">
                <label class="required form-label">Término da campanha</label>
                <DateTimeInput
                  v-model.trim="form.end_date"
                  format="dd/MM/yyyy"
                  type="date"
                  theme="basic"
                  class="mx-2"
                  placeholder="Término"
                />
              </div>
            </div>
            <div class="form-group row mb-5">
              <div class="col-12">
                <label class="required form-label">Taxa de câmbio contratada</label>
                <Money
                  class="form-control"
                  v-model.trim="form.exchange_rate_amount"
                  v-bind="money"
                />
              </div>
            </div>
          </template>
          <div class="form-group row mb-5">
            <div class="col-12">
              <label class="required form-label">CPC vendido</label>
              <Money
                class="form-control"
                v-model.trim="form.sold_cpc"
                v-bind="money"
              />
            </div>
          </div>

          <div class="mt-5 text-center">
            <Button
              class="btn btn-primary"
              @click="submit"
              :loading="loader"
            >
              Importar
            </Button>
          </div>
        </form>
    </div>
  </b-modal>
</template>

<script>

import { parseErrorResponseToArray } from '@/utils'
import AdvertisersService from '@/modules/advertisers/services/advertisers-service'
import CampaignsService from '@/modules/campaigns/services/campaigns-service'
import CompaniesService from '@/modules/companies/services/companies-service'
import NotificationService from '@/modules/notifications/services/notifications-service'

import AlertWraper from '@/components/common/Alert/AlertWraper'
import Button from '@/components/common/Button/Button'
import DateTimeInput from '@/components/common/Input/DateTimeInput'
import { Money } from 'v-money'
import SelectAdvertiserInput from '@/components/advertisers/SelectAdvertiserInput'
import SelectCompanyInput from '@/components/common/Select/SelectCompanyInput'

export default {
  name: 'ImportCampaignModal',
  props: ['campaign', 'platform', 'partner', 'advertiserId'],
  components: {
    AlertWraper,
    Button,
    DateTimeInput,
    Money,
    SelectAdvertiserInput,
    SelectCompanyInput
  },
  data () {
    return {
      advertiser: '',
      company: '',
      content: null,
      content_type: 'error',
      form: {
        partner: '',
        advertiser_id: '',
        campaign_id: '',
        company_id: '',
        campaign_type: '',
        end_date: '',
        exchange_rate_amount: 0,
        platform: '',
        sold_cpc: 0,
        sold_amount: 0,
        start_date: ''
      },
      loader: false,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false
      }
    }
  },
  created () {
  },
  watch: {
    'form.advertiser_id': function (newVal) {
      if (this.platform === 'MGID') this.getAdvertiser(newVal)
    },
    'form.company_id': function (newVal) {
      this.getCompany(newVal)
    }
  },
  methods: {
    /**
     * Get advertiser
     */
    async getAdvertiser (id) {
      try {
        this.advertiser = await AdvertisersService.getAdvertiser(id)
      } catch (error) {
        this.content = parseErrorResponseToArray(error)
      }
    },
    /**
     * Get company
     */
    async getCompany (id) {
      try {
        this.company = await CompaniesService.getCompany(id)
      } catch (error) {
        this.content = parseErrorResponseToArray(error)
      }
    },
    /**
     * On modal hidden
     */
    hidden () {
      this.content = null
      this.form.advertiser_id = ''
      this.form.campaign_id = ''
      this.form.sold_amount = 0
      this.form.sold_cpc = 0
      this.form.exchange_rate_amount = 0
    },
    /**
     * On modal shown
    */
    shown () {
      this.form.partner = this.partner
      this.form.platform = this.platform
      this.form.campaign_id = this.campaign.id
      if (this.platform !== 'MGID') this.form.advertiser_id = this.advertiserId
    },
    /**
     * Submit form
     */
    async submit () {
      this.loader = true
      this.content = null
      try {
        const form = JSON.parse(JSON.stringify(this.form))
        if (this.platform === 'MGID') {
          delete form.campaign_type
          delete form.company_id
        }
        form.sold_cpc = parseInt(form.sold_cpc * 100)
        form.sold_amount = parseInt(form.sold_amount * 100)
        form.exchange_rate_amount = parseInt(form.exchange_rate_amount * 100)

        await CampaignsService.importCampaign(form)

        this.$bvModal.hide('import-campaign-modal')

        const notification = {
          notification: {
            type: 'success',
            content: 'Campanha importada com sucesso'
          }
        }
        NotificationService.createGlobalSuccessNotification(notification)
      } catch (error) {
        this.content = parseErrorResponseToArray(error)
      }

      this.loader = false
    }
  }
}
</script>
